export class Credentials {
  constructor(public email: string, public password: string) {}

  get isValid(): boolean {
    return Object.keys(this).every(k => !!this[k]);
  }
}
